import React, { useEffect, useState } from "react";
import styles from "./ContactUs.module.scss";
import MyButton from "../UI/MyButton/MyButton";
import { PUBLIC_IMAGE } from "../../constants";
import MyInput from "../UI/MyInput/MyInput";
import formStore from "../../stores/formStore";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm, ValidationError } from "@formspree/react";
import { useNavigate } from "react-router";

const ContactUs = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [state, handleSubmit] = useForm("xnnvykgl");

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const handleCaptchaChange = (token: string | null) => {
    formStore.setCaptchaToken(token);
  };

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  if (state.succeeded) {
    return <p>Thanks for joining!</p>;
  }

  return (
    <>
      <a
        href="https://t.me/ALFA_CRYPTO_SUPPORT"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.contactUs__button__active}
      >
        <img src={PUBLIC_IMAGE + "ContactUs.svg"} alt="Contact us" />
      </a>
      <div
        onClick={toggleVisibility}
        className={`${
          visible
            ? styles.contactUs__container__active
            : styles.contactUs__container__hidden
        }`}
      >
        <div className={styles.contactUs__content}>
          <div className={styles.contactUs__content__title}>Contact us</div>
          <div className={styles.contactUs__content__subtitle}>
            Start a dialogue with our manager right away.
          </div>
          <div>
            <MyButton className={styles.contactUs__button}>Telegram</MyButton>
          </div>
        </div>
        <form
          className={styles.contactUs__form}
          onClick={(e) => e.stopPropagation()}
          onSubmit={handleSubmit}
        >
          <div className={styles.contactUs__form__body}>
            <div className={styles.contactUs__form__inputs}>
              <div className={styles.contactUs__form__inputs__title__wrapper}>
                <label className={styles.contactUs__input__label}>Email</label>
                <MyInput
                  id="email"
                  type="email"
                  name="email"
                  className={styles.contactUs__input}
                  placeHolder="Enter your email"
                />
              </div>
              <div className={styles.contactUs__form__inputs__title__wrapper}>
                <label className={styles.contactUs__input__label}>
                  Your name
                </label>
                <MyInput
                  id="name"
                  type="name"
                  name="name"
                  className={styles.contactUs__input}
                  placeHolder="Enter your name"
                />
              </div>
            </div>
            <div className={styles.contactUs__form__textareaAndButton}>
              <div className={styles.contactUs__form__textarea__wrapper}>
                <label className={styles.contactUs__input__label}>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className={styles.contactUs__form__textarea}
                  placeholder="Message"
                />
              </div>
              <div>
                <ReCAPTCHA
                  sitekey="6LffE8IqAAAAAM3RixTIrXWK--794V01rKbaJCio"
                  onChange={handleCaptchaChange}
                  theme="light"
                />
              </div>
            </div>
          </div>
          <div className={styles.contactUs__form__button}>
            <MyButton className={styles.contactUs__form__button__submit}>
              Send Message
            </MyButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactUs;
